/**
 * Product page FAQ
 * Reads the JSON in #pc-faq-data (rendered by sections/product-conversion.liquid) and inserts a
 * "Questions" stack inside the description, after Suggested use and before Good to know /
 * Ingredients, so all the collapsible rows sit together. product-conversion.js (loaded first)
 * moves the description into the buy box under Add to Cart.
 * Fallbacks: end of the description, then its own block after the buy buttons.
 * Logs "[pc-faq]" messages to the console so a failure is visible.
 */
(function () {
  var done = false;

  function findTarget() {
    var inBox = document.querySelector('[id^="ProductInfo-"] .product__description');
    if (inBox) return { desc: inBox };
    var descs = Array.prototype.filter.call(
      document.querySelectorAll('.product__description'),
      function (el) {
        return !el.closest('.product-recommendations, .card, .card-wrapper, quick-add-modal') &&
          el.getClientRects().length > 0;
      }
    );
    if (descs.length) return { desc: descs[0] };
    var form = document.querySelector('[id^="ProductInfo-"] product-form, [id^="ProductInfo-"] .product-form');
    if (form) return { form: form };
    return null;
  }

  function build() {
    if (done) return true;
    var src = document.getElementById('pc-faq-data');
    if (!src) return false;
    var items;
    try { items = JSON.parse(src.textContent); } catch (e) {
      console.warn('[pc-faq] could not parse FAQ data', e);
      done = true;
      return true;
    }
    if (!items || !items.length) { done = true; return true; }

    var target = findTarget();
    if (!target) return false;

    var wrap = document.createElement('div');
    wrap.className = 'pc-faq';
    var label = document.createElement('p');
    label.className = 'pc-faq__label';
    label.textContent = 'Questions';
    wrap.appendChild(label);

    items.forEach(function (it) {
      var d = document.createElement('details');
      d.className = 'pc-ingredients pc-faq__item';
      var s = document.createElement('summary');
      s.textContent = it.q;
      var p = document.createElement('p');
      p.innerHTML = it.a; // authored in the theme, not user input
      d.appendChild(s);
      d.appendChild(p);
      wrap.appendChild(d);
    });

    if (target.desc) {
      var before = target.desc.querySelector(':scope > .pc-goodtoknow') ||
        target.desc.querySelector(':scope > .pc-ingredients');
      var after = target.desc.querySelector(':scope > .pc-use');
      if (before) before.insertAdjacentElement('beforebegin', wrap);
      else if (after) after.insertAdjacentElement('afterend', wrap);
      else target.desc.appendChild(wrap);
    } else {
      var el = target.form.closest('.buttons-card-buy') || target.form;
      el.insertAdjacentElement('afterend', wrap);
    }
    done = true;
    console.info('[pc-faq] inserted ' + items.length + ' rows');
    return true;
  }

  function attempt(n) {
    try {
      if (build()) return;
    } catch (e) {
      console.warn('[pc-faq] error', e);
      return;
    }
    if (n > 0) setTimeout(function () { attempt(n - 1); }, 400);
    else console.warn('[pc-faq] no description or product form found');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attempt(10); });
  } else {
    attempt(10);
  }
})();
